import { useEffect, useState, useRef } from "react";

import { useCardFunc } from "../../hooks";

import {
  Flex,
  Box,
  Img,
  Spacer,
  Center,
  Button,
  Input,
  Select,
  useOutsideClick,
} from "@chakra-ui/react";

import { options, add, crossShort } from "../../assets";

import { Cards, CardText } from "./style";

export const Card = ({
  id,
  num,
  name,
  cardValue,
  create,
  addCard,
  deleteCard,
  handleNameChange,
  handleOptionChange,
}) => {
  const {
    hovered,
    setHovered,
    toggleName,
    nameEdit,
    setNameEdit,
    optionEdit,
    setOptionEdit,
    toggleOption,
  } = useCardFunc();

  const optionRef = useRef();
  const nameRef = useRef();

  const [fonts, setAllFonts] = useState(["Nunito"]);
  const [currFont, setFonts] = useState("Alef");

  var WebFont = require("webfontloader");

  const { REACT_APP_GFONT_API } = process.env;

  useEffect(() => {
    const fetchData = async () => {
      let result = await fetch(
        `https://www.googleapis.com/webfonts/v1/webfonts?key=${REACT_APP_GFONT_API} `
      );
      const data = await result.json();
      const res = data.items;
      let val = res.map((fam) => fam.family);
      let list = val;
      // let list = val.slice(0, 100);
      setAllFonts(list);
      // console.log(fonts);
    };

    fetchData();
    // eslint-disable-next-line
  }, []);

  WebFont.load({
    google: {
      families: [currFont],
    },
  });

  // console.log(optionEdit);
  // console.log(ref.current);

  useOutsideClick({
    ref: optionRef,
    handler: () => setOptionEdit(false),
  });
  useOutsideClick({
    ref: nameRef,
    handler: () => setNameEdit(false),
  });

  return (
    // THIS IS THE TRIAL ONE CHANEG VALUES TO AND MATCH IT TO CARD THIS WILL BE MAIN EXPORT NO MATTER WHAT
    // TRY TO MATCH WITH CARDFINAL
    <Cards
      width={{ base: "304px", md: "304px", lg: "395px" }}
      height={{ base: "400px", md: "400px", lg: "504px" }}
      p={{ base: "25px", md: "25px", lg: "30px" }}
      borderRadius="6px"
      key={id}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      <Flex align="center">
        <Box>
          <Img
            boxSize={{ base: "34px", md: "34px", lg: "40px" }}
            src={options}
            alt="opt"
          />
        </Box>
        <Spacer />
        <Box>
          <CardText
            fontSize={{ base: "22px", md: "22px", lg: "26px" }}
            lineHeight={{ base: "24px", md: "24px", lg: "32px" }}
            fontWeight="bold"
          >
            {create ? (
              "∞"
            ) : id !== 0 ? (
              hovered ? (
                <button onClick={deleteCard} p={0} m={0}>
                  <Img
                    boxSize={{ base: "20px", md: "20px", lg: "30px" }}
                    src={crossShort}
                  />
                </button>
              ) : (
                `-0${num}`
              )
            ) : (
              `-0${num}`
            )}
          </CardText>
        </Box>
      </Flex>
      <Center height={{ base: "296px", md: "290px", lg: "380px" }}>
        {create ? (
          // FIXME: change the Button SYTLE
          <button onClick={addCard} _focus={{ border: "none" }}>
            <Img
              boxSize={{ base: "56px", md: "56px", lg: "68px" }}
              src={add}
              alt="+"
            />
          </button>
        ) : (
          <Flex flexDir="column" alignItems="center">
            <CardText
              fontFamily={cardValue} // Font Variable
              fontWeight="bold"
              fontSize={{ base: "42px", md: "42px", lg: "50px" }}
              lineHeight={{ base: "auto", md: "44px", lg: "56px" }}
            >
              Ag
            </CardText>
            <CardText
              fontFamily="'Roboto', sans-serif"
              fontSize={{ base: "18px", md: "18px", lg: "20px" }}
              lineHeight={["24px"]}
              mt="8px"
            >
              <Button
                onKeyDown={(e) => toggleOption(e)}
                colorScheme="black"
                variant="link"
                onClick={toggleOption}
                fontSize={{ base: "22px", md: "26px", lg: "26px" }}
                fontWeight="normal"
                lineHeight={["32px"]}
              >
                {optionEdit ? (
                  <div ref={optionRef}>
                    <Select
                      placeholder={cardValue}
                      onChange={(e) => {
                        setFonts(e.target.value);
                        handleOptionChange(e, id);
                      }}
                    >
                      {fonts.map((val) => {
                        return <option>{val}</option>;
                      })}
                    </Select>
                  </div>
                ) : (
                  cardValue
                )}
              </Button>
            </CardText>
          </Flex>
        )}
      </Center>
      <CardText
        fontSize={{ base: "22px", md: "22px", lg: "26px" }}
        lineHeight={{ base: "24px", md: "24px", lg: "32px" }}
      >
        {create ? (
          "Create"
        ) : (
          <Button
            onKeyDown={(e) => toggleName(e)}
            colorScheme="black"
            variant="link"
            onClick={toggleName}
            fontWeight="normal"
            fontSize={{ base: "22px", md: "22px", lg: "26px" }}
            lineHeight={{ base: "24px", md: "24px", lg: "32px" }}
          >
            {nameEdit ? (
              <div ref={nameRef}>
                <Input
                  variant="flushed"
                  placeholder={name}
                  maxlength="20"
                  onChange={(e) => handleNameChange(e, id)}
                />
              </div>
            ) : (
              name
            )}
          </Button>
        )}
      </CardText>
    </Cards>
  );
};
